/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import { currency, downloadFile, getFileNameFromUrl } from '@global/helpers';
import TitleSubSection from '@components/global/TitleSubSection';
import StatusBadge from '@components/global/StatusBadge';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

// eslint-disable-next-line react/prop-types
const TodoListInvoice = ({ detailTodos = [] }) => {
  const dataInvoiceCollection = detailTodos.find(
    (a) => a.target_type == 'invoice_collection',
  );
  let invoices = [];
  if (dataInvoiceCollection) {
    const detailInvoice = dataInvoiceCollection.more_info || {};
    invoices = detailInvoice.notes?.length
      ? detailInvoice.notes.filter((a) => a.type == 'invoice')
      : [];
  }

  return (
    <View testID="todo-invoice-list-container" style={{ width: '100%' }}>
      <TitleSubSection title="INVOICE COLLECTION NOTES" />
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          padding: 15,
        }}>
        {invoices?.length ? (
          invoices.map((item, idx) => (
            <View
              style={{
                width: isWeb ? '48%' : '100%',
                maxWidth: isWeb ? '48%' : '100%',
                borderRadius: 5,
                backgroundColor: Colors.grey0,
                padding: 15,
                marginBottom: isWeb ? 0 : 15,
              }}
              key={idx}>
              <SociollaText style={{ fontSize: 13 }}>
                Invoice Number
              </SociollaText>
              <SociollaText type="medium">
                {item.invoice_number?.length
                  ? item.invoice_number.join(',')
                  : '-'}
              </SociollaText>
              <SociollaText style={{ fontSize: 13, marginTop: 5 }}>
                Amount
              </SociollaText>
              <SociollaText type="medium">
                {item.amount_invoice || item.amount_invoice === 0
                  ? currency(item.amount_invoice, true)
                  : '-'}
              </SociollaText>
              <SociollaText style={{ fontSize: 13, marginTop: 5 }}>
                Status
              </SociollaText>
              <View style={{ alignSelf: 'flex-start', marginBottom: 5 }}>
                {item.status_invoice ? (
                  <StatusBadge status={item.status_invoice} />
                ) : (
                  <SociollaText>-</SociollaText>
                )}
              </View>
              <SociollaText style={{ fontSize: 13, marginTop: 5 }}>
                Notes
              </SociollaText>
              <SociollaText>{item.text || '-'}</SociollaText>
              {!!item.invoice_attachment_url && (
                <>
                  <SociollaText style={{ fontSize: 13, marginTop: 5 }}>
                    Attachment
                  </SociollaText>
                  <TouchableOpacity
                    testID={`todo-invoice-list-attachment-btn-${idx}`}
                    activeOpacity={0.7}
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      alignSelf: 'flex-start',
                      marginTop: 2,
                    }}
                    onPress={() =>
                      downloadFile(
                        item.invoice_attachment_url,
                        'invoice-attachment',
                        '',
                        true,
                      )
                    }>
                    <Image
                      style={{ width: 16, height: 16, marginRight: 6 }}
                      width={16}
                      height={16}
                      isResolveAsset
                      source={require('@/assets/img/icons/attachment.png')}
                    />
                    <SociollaText
                      type="medium"
                      numberOfLines={1}
                      style={{ color: Colors.blue0 }}>
                      {getFileNameFromUrl(
                        item.invoice_attachment_url,
                        'Invoice',
                      )}
                    </SociollaText>
                  </TouchableOpacity>
                </>
              )}
            </View>
          ))
        ) : (
          <SociollaText>No invoice found</SociollaText>
        )}
      </View>
    </View>
  );
};

export default React.memo(TodoListInvoice, (prev, next) => prev == next);
